import { ApiUtil as api } from "@/utils/api.util.js";

export class KeyService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/keys/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }

  static create(queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams);
  }

  static delete(id, queryParams = {}) {
    return api.delete(this.URL + this.RESOURCE + id, queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/key.service.js